import React from "react";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CRow,
  CCol,
  CImage,
  CButton,
  CListGroup,
  CListGroupItem,
} from "@coreui/react";
import PropTypes from "prop-types";

const Preview = ({ data = {}, images = {}, onBack, onSubmit }) => {
  return (
    <CCard className="mb-4">
      <CCardHeader>
        <strong>Preview - Loan Application</strong>
      </CCardHeader>
      <CCardBody>
        {/* Personal Information */}
        <CCard className="mb-4">
          <CCardHeader>
            <h5>Personal Information</h5>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Full Name:</strong> {data?.fullName || "-"}
                </p>
                <p>
                  <strong>Email:</strong> {data?.email || "-"}
                </p>
                <p>
                  <strong>Phone:</strong> {data?.phone || "-"}
                </p>
                <p>
                  <strong>Date of Birth:</strong> {data?.dob || "-"}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>{"Father's Name:"}</strong> {data?.fatherName || "-"}
                </p>
                <p>
                  <strong>Gender:</strong> {data?.gender || "-"}
                </p>
                <p>
                  <strong>Marital Status:</strong> {data?.martialStatus || "-"}
                </p>
                <p>
                  <strong>Occupation:</strong> {data?.occupation || "-"}
                </p>
                <p>
                  <strong>Employment Start Date:</strong>{" "}
                  {data?.empStartDate || "-"}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Loan Information */}
        <CCard className="mb-4">
          <CCardHeader>
            <h5>Loan Information</h5>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Loan Type:</strong> {data?.loanType || "-"}
                </p>
                <p>
                  <strong>Loan Amount Requested:</strong> ₹
                  {data?.loanAmountRequested || "-"}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>Loan Term (months):</strong> {data?.loanTerm || "-"}
                </p>
                <p>
                  <strong>Branch:</strong> {data?.branchId || "-"}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Address Information */}
        <CCard className="mb-4">
          <CCardHeader>
            <h5>Address Information</h5>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Plot/House No:</strong> {data?.plot_no || "-"}
                </p>
                <p>
                  <strong>City:</strong> {data?.city || "-"}
                </p>
                <p>
                  <strong>State:</strong> {data?.state || "-"}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>Country:</strong> {data?.country || "-"}
                </p>
                <p>
                  <strong>Pincode:</strong> {data?.pincode || "-"}
                </p>
                <p>
                  <strong>Landmark:</strong> {data?.landmark || "-"}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Bank & Income Details */}
        <CCard className="mb-4">
          <CCardHeader>
            <h5>Bank & Income Details</h5>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Bank Name:</strong> {data?.bankName || "-"}
                </p>
                <p>
                  <strong>Branch Name:</strong> {data?.branchName || "-"}
                </p>
                <p>
                  <strong>Account Number:</strong> {data?.accountNumber || "-"}
                </p>
                <p>
                  <strong>IFSC Code:</strong> {data?.ifsc || "-"}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>Credit Score:</strong> {data?.creditScore || "-"}
                </p>
                <p>
                  <strong>Monthly Income:</strong> ₹{data?.income || "-"}
                </p>
                <p>
                  <strong>Monthly Expenses:</strong> ₹
                  {data?.monthlyExpenses || "-"}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Identity Documents */}
        <CCard className="mb-4">
          <CCardHeader>
            <h5>Identity Documents</h5>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Aadhar Number:</strong> {data?.aadharNumber || "-"}
                </p>
                <p>
                  <strong>PAN Number:</strong> {data?.panNumber || "-"}
                </p>
              </CCol>
              <CCol md={6}>
                <div className="d-flex flex-wrap gap-3">
                  {data?.aadharImageUrl && (
                    <div className="text-center">
                      <CImage
                        thumbnail
                        src={data?.aadharImageUrl}
                        width={150}
                      />
                      <p>Aadhar Card</p>
                    </div>
                  )}
                  {data?.panImageUrl && (
                    <div className="text-center">
                      <CImage thumbnail src={data?.panImageUrl} width={150} />
                      <p>PAN Card</p>
                    </div>
                  )}
                  {data?.passportSizePhoto && (
                    <div className="text-center">
                      <CImage
                        thumbnail
                        src={data?.passportSizePhoto}
                        width={150}
                      />
                      <p>Passport Photo</p>
                    </div>
                  )}
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Financial Documents */}
        <CCard className="mb-4">
          <CCardHeader>
            <h5>Financial Documents</h5>
          </CCardHeader>
          <CCardBody>
            <div className="d-flex flex-wrap gap-3">
              {data?.bankStatementsImageUrl && (
                <div className="text-center">
                  <CImage
                    thumbnail
                    src={data?.bankStatementsImageUrl}
                    width={150}
                  />
                  <p>Bank Statement</p>
                </div>
              )}
              {data?.paySlipImageUrl && (
                <div className="text-center">
                  <CImage thumbnail src={data?.paySlipImageUrl} width={150} />
                  <p>Pay Slip</p>
                </div>
              )}
              {data?.singnatureImageUrl && (
                <div className="text-center">
                  <CImage
                    thumbnail
                    src={data?.singnatureImageUrl}
                    width={150}
                  />
                  <p>Signature</p>
                </div>
              )}
            </div>
          </CCardBody>
        </CCard>

        {/* Guarantor Information */}
        <CCard className="mb-4">
          <CCardHeader>
            <h5>Guarantor Information</h5>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={6}>
                <h6>First Guarantor</h6>
                <p>
                  <strong>Name:</strong> {data?.GuarantorName || "-"}
                </p>
                <p>
                  <strong>{"Father's Name:"}</strong> {data?.fathersName || "-"}
                </p>
                <p>
                  <strong>Mobile Number:</strong> {data?.mobileNumber || "-"}
                </p>
                <p>
                  <strong>PAN:</strong> {data?.pan || "-"}
                </p>
                <p>
                  <strong>Aadhar:</strong> {data?.aadhar || "-"}
                </p>
                <p>
                  <strong>Address:</strong> {data?.address || "-"}
                </p>
              </CCol>
              <CCol md={6}>
                <h6>Second Guarantor</h6>
                <p>
                  <strong>Name:</strong> {data?.GuarantorName1 || "-"}
                </p>
                <p>
                  <strong>{"Father's Name:"}</strong>{" "}
                  {data?.fathersName1 || "-"}
                </p>
                <p>
                  <strong>Mobile Number:</strong> {data?.mobileNumber1 || "-"}
                </p>
                <p>
                  <strong>PAN:</strong> {data?.pan1 || "-"}
                </p>
                <p>
                  <strong>Aadhar:</strong> {data?.aadhar1 || "-"}
                </p>
                <p>
                  <strong>Address:</strong> {data?.address1 || "-"}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* References */}
        <CCard className="mb-4">
          <CCardHeader>
            <h5>References</h5>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md={6}>
                <h6>Personal Reference</h6>
                <p>
                  <strong>Name:</strong> {data?.refName || "-"}
                </p>
                <p>
                  <strong>Phone Number:</strong>{" "}
                  {data?.referencePhoneNumber || "-"}
                </p>
              </CCol>
              <CCol md={6}>
                <h6>Professional Reference</h6>
                <p>
                  <strong>Name:</strong> {data?.nameProfessional || "-"}
                </p>
                <p>
                  <strong>Phone Number:</strong>{" "}
                  {data?.phoneNumberProfessional || "-"}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        {/* Action Buttons */}
        <div className="d-flex justify-content-between mt-4">
          <CButton
            color="secondary"
            onClick={onBack}
            style={{
              padding: "10px 20px",
            }}
          >
            Back
          </CButton>
          {/* <CButton
            color="success"
            onClick={onSubmit}
            style={{
              background:
                "linear-gradient(135deg, rgb(30, 38, 57), rgb(76, 90, 122), rgb(124, 144, 194))",
              padding: "10px 20px",
            }}
          >
            Submit Application
          </CButton> */}
        </div>
      </CCardBody>
    </CCard>
  );
};

Preview.propTypes = {
  data: PropTypes.object.isRequired,
  images: PropTypes.object,
  onBack: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

Preview.defaultProps = {
  images: {},
};

export default Preview;
